import {createContext, useContext} from 'react';

import {HandlerOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';

/*
 * Props.
 */

export interface FrameContextProps {
  updateTitle: HandlerOf<string>;
}

/*
 * Context.
 */

export const FrameContext = createContext<FrameContextProps>({updateTitle: () => {}});

/*
 * Hook.
 */

export function useFrameContext() {
  return useContext(FrameContext);
}
